export enum AnalyticsActions {
    DR_LEADFORM_SKIPPED = 'DR_LEADFORM_SKIPPED'
}
